<ng-container *ngIf="generalSettingsData">
<button class="no-style my-links-btn" [ngClass]="{ opened: opened }" (click)="opened = !opened">
  {{generalSettingsData.portalGeneralSettingsData.mylinksTitleValue}}
  <mat-icon [svgIcon]="'arrow-down'" class="square-icon dropdown-arrow"></mat-icon>
</button>

<div class="my-links-list" [@openClose]="opened ? 'opened' : 'closed'">
  <a *ngFor="let link of generalSettingsData.portalGeneralSettingsData.myLinksListValue" href="{{link.url}}" class="list-item">{{link.name}}</a>
</div>
</ng-container>